import { render, staticRenderFns } from "./IconFunctionSupports.vue?vue&type=template&id=64d277b3&"
import script from "./IconFunctionSupports.vue?vue&type=script&lang=ts&"
export * from "./IconFunctionSupports.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports